import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Clock, Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getQuestionPacks } from "@/lib/study-monetization.functions";
import { PROPOSED_CREDIT_PACKS } from "@/lib/study-policy";
import { STUDY_NEW_CHECKOUT_RELEASED } from "@/lib/study-billing-contract";

export function QuestionCreditStore({ resetAt, exhausted = false }: { resetAt?: string; exhausted?: boolean }) {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);
  const [packs, setPacks] = useState<Array<{ pack_id: string; name: string; questions: number; price_minor: number; currency: string }>>(PROPOSED_CREDIT_PACKS.map(p => ({ ...p, currency: "USD" })));
  useEffect(() => {
    let disposed = false;
    if (STUDY_NEW_CHECKOUT_RELEASED) getQuestionPacks().then(rows => { if (!disposed && rows.length) setPacks(rows); }).catch(() => {});
    return () => { disposed = true; };
  }, []);
  if (!STUDY_NEW_CHECKOUT_RELEASED || dismissed) return null;
  return <section className="space-y-4 border-t border-rule py-6">
    <div className="flex items-start justify-between gap-3">
      <div>
        <h2 className="text-lg font-bold text-ink">{t("monetization.question_credit_store")}</h2>
        {exhausted && <p className="mt-2 text-sm text-ink-muted">{t("monetization.you_ve_completed_your_50_premium_questions_for_today_your_daily_ques")}</p>}
      </div>
      <Button variant="ghost" size="icon" aria-label={t("monetization.dismiss_question_packs")}  title={t("monetization.dismiss")}  onClick={() => setDismissed(true)}><X /></Button>
    </div>
    <div className="grid gap-3 sm:grid-cols-3">
      {packs.map(pack => <article key={pack.pack_id} className="flex flex-col gap-3 rounded-lg border border-rule bg-card p-4">
        <Plus className="size-5 text-neon-pink" />
        <h3 className="font-bold text-ink">{pack.name}</h3>
        <p className="text-2xl font-bold text-ink">{pack.questions}<span className="block text-xs font-normal text-ink-muted">{t("monetization.additional_questions")}</span></p>
        <p className="text-sm font-semibold text-ink">{new Intl.NumberFormat(undefined, { style: "currency", currency: pack.currency }).format(pack.price_minor / 100)}</p>
        <Button variant="subtle" className="mt-auto whitespace-normal" disabled>{t("monetization.not_available_yet")}</Button>
      </article>)}
    </div>
    <p className="text-xs text-ink-muted">{t("monetization.proposed_packs_one_time_payment_no_automatic_renewal_unused_question")}</p>
    {resetAt && <p className="flex items-center gap-2 text-xs text-ink-muted"><Clock className="size-4" /> Daily reset: {new Date(resetAt).toLocaleString()} (midnight UTC)</p>}
  </section>;
}